<template>
  <div class="contacto-section py-4">
    <div class="container">
      <div class="row g-4 align-items-center">
        <!-- Columna de información -->
        <div class="col-12 col-md-5 contacto-info" data-aos="fade-up" data-aos-duration="1200">
          <h2 class="contacto-title">{{ content.title }}</h2>
          <p class="contacto-desc">
            {{ content.description }}
          </p>
        </div>
        <!-- Columna del formulario -->
        <div class="col-12 col-md-7">
          <form class="contacto-form" @submit.prevent="submitForm">
            <div class="mb-2" data-aos="fade-right" data-aos-duration="6000">
              <label class="form-label">{{ content.form.name }}*</label>
              <input
                type="text"
                class="form-control"
                :placeholder="content.form.name"
                v-model="formData.name"
              />
            </div>
            <div class="mb-2" data-aos="fade-left" data-aos-duration="6000">
              <label class="form-label">{{ content.form.email }}*</label>
              <input
                type="email"
                class="form-control"
                :placeholder="content.form.email"
                v-model="formData.email"
              />
            </div>
            <div class="mb-2" data-aos="fade-right" data-aos-duration="6000">
              <label class="form-label">{{ content.form.company }}*</label>
              <input
                type="text"
                class="form-control"
                :placeholder="content.form.company"
                v-model="formData.company"
              />
            </div>
            <div class="mb-2" style="position:relative; z-index: 3;" data-aos="fade-left" data-aos-duration="6000">
              <label class="form-label">{{ content.form.subject }}*</label>
              <select
                class="form-select"
                v-model="formData.subject"
                style="background: #fff;"
              >
                <option value="" disabled>{{ content.form.subjectPlaceholder }}</option>
                <option
                  v-for="option in content.form.subjectOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="mb-3" data-aos="fade-right" data-aos-duration="6000">
              <label class="form-label">{{ content.form.message }}*</label>
              <textarea
                class="form-control"
                :placeholder="content.form.message"
                rows="3"
                v-model="formData.message"
              ></textarea>
            </div>
            <button type="submit" class="btn btn-dark w-100 contacto-send-btn" :disabled="loading">
              {{ loading ? 'Enviando...' : content.form.send }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactoContent } from '@/assets/data/data.ts';
import AOS from 'aos'
import 'aos/dist/aos.css'
import axios from 'axios';

export default {
  name: 'ContactoForm',
  props: {
    selectedLang: {
      type: String,
      default: 'es'
    }
  },
  data() {
    return {
      formData: {
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      },
      loading: false,
      error: null
    };
  },
  computed: {
    content() {
      return contactoContent[this.selectedLang] || contactoContent.es;
    }
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  },
  methods: {
    async submitForm() {
      const { name, email, company, subject, message } = this.formData;

      if (!name || !email || !company || !subject || !message) {
        this.showToast('Por favor, completa todos los campos obligatorios.', 'error');
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showToast('Por favor, ingrese un correo valido.', 'error');
        return;
      }

      const emal = {
        nombre: name,
        correo: email,
        mensaje: `
          Empresa: ${company}\n
          Asunto: ${subject}\n
          Mensaje:\n${message}
        `
      };

      try {
        this.loading = true;
        this.error = null;

        await axios.post('https://api.frenkel.com.mx/mail', emal, {
          headers: { 'Content-Type': 'application/json' }
        });

        this.showToast('¡Formulario enviado con éxito!', 'success');

        // Reiniciar formulario
        this.formData = {
          name: '',
          email: '',
          company: '',
          subject: '',
          message: ''
        };
      } catch (e) {
        this.error = 'Error al enviar el formulario.';
        this.showToast(this.error, 'error');
      } finally {
        this.loading = false;
      }
    },

    showToast(message, type = 'success') {
      const bgColor = type === 'success' ? '#2c74b8' : '#dc3545';
      const toast = document.createElement('div');
      toast.textContent = message;
      toast.style.cssText = `
        position: fixed;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        background: ${bgColor};
        color: white;
        padding: 12px 20px;
        border-radius: 5px;
        z-index: 9999;
        font-family: 'IBM Plex Mono', monospace;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        animation: fadeInOut 3.5s forwards;
      `;
      document.body.appendChild(toast);

      setTimeout(() => {
        toast.remove();
      }, 3500);
    }
  }
};
</script>

<style scoped>
.contacto-section {
  background: #f6fafb;
  /* quita overflow, NO uses overflow:hidden ni auto aquí */
}
.contacto-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.4rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
}
.contacto-title::after{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.contacto-title:hover::after{
  width: 100%;
}
.contacto-desc {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  white-space: pre-line;
  margin-bottom: 0;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
}
.contacto-desc::after{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.contacto-desc:hover::after{
  width: 90%;
  opacity: .2;
}
.contacto-form .form-label {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.93rem;
}
.contacto-form .form-control,
.contacto-form .form-select {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.97rem;
  background: #fff;
}
.contacto-send-btn {
  font-family: 'Caveat-Bold', cursive;
  font-size: 1.35rem;
  border-radius: 999px;
  margin-top: 8px;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}
.contacto-send-btn:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  color: #ffffff
}
input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #2c74b8;
  box-shadow: 0 0 0 4px rgba(44, 116, 184, 0.2);
  transform: scale(1.02);
  transition: all 0.25s ease;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
  10% { opacity: 1; transform: translateX(-50%) translateY(0); }
  90% { opacity: 1; }
  100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}
@media (max-width: 767.98px) {
  .contacto-title {
    font-size: 2rem;
  }
}
</style>
